import React from "react";

const Scholarships = () => {
  return <div></div>;
};

export default Scholarships;
